import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import Routes from 'routes/index';
import { Provider } from 'react-redux';
import store from 'redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from 'containers/LoadingOverlay';

const App = (): JSX.Element => {
    return (
        <Provider store={store}>
            <Router basename={'/'}>
                <Routes />
                <ToastContainer theme="dark" />
                <LoadingOverlay />
            </Router>
        </Provider>
    );
};

export default App;
